import { getAddress } from '@multiversx/sdk-dapp/utils/account'
import { sendTransactions } from '@multiversx/sdk-dapp/services'
import { logout } from '@multiversx/sdk-dapp/utils'
import { IMultiversxAdapter } from './BlockchainAdapter.types'

class MultiversXAdapter implements IMultiversxAdapter {
  async disconnect(): Promise<void> {
    return new Promise(() => {
      logout()
    })
  }

  async sendTransaction(payload: any): Promise<void> {
    return new Promise((resolve) => {
      resolve(sendTransactions(payload))
    })
  }

  async getAddress(): Promise<string> {
    return new Promise((resolve) => {
      getAddress().then((address) => {
        resolve(address)
      })
    })
  }
}

export default MultiversXAdapter
